// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"a34198f5","355":"cf5b5bb5","460":"179cb531","645":"29a80490","787":"7c42db31","818":"af41b170"}[chunkId] + ".chunk.js";
};